module.exports = __webpack_public_path__ + "img/performance.b3e23f5c.svg";